import { Injectable } from '@angular/core';
import { Globals } from 'projects/core/src/globals';
import { WSService } from 'projects/core/src/include/service';
import { Observable } from 'rxjs';
import { NotificationLog} from '../db/notification';






@Injectable({
  providedIn: 'root'
})
export class NotificationLogsService extends WSService<NotificationLog> {

  constructor() { super("notificationlogs")};

  getNotifications(id_address:number){
    return  Globals.ws.requestUrl<NotificationLog[]>("notificationlogs","getItems",["id_address="+id_address.toString()]);
  }
}
